import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2, Target, Brain, Wallet, Workflow, Users, Calendar, Clock, PhoneCall, Mail, ChevronRight, MessageCircle, Flame, BarChart3, TrendingUp, Sparkles, Shield } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
const sectionFade = {
  hidden: {
    opacity: 0,
    y: 12
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
const services = [{
  icon: <Brain className="h-6 w-6" aria-hidden data-id="element-5" data-mp="pgsa222ky2w4" />,
  title: 'AI Consulting',
  desc: 'Strategic guidance on leveraging artificial intelligence to enhance both personal growth journeys and business team operations.'
}, {
  icon: <Workflow className="h-6 w-6" aria-hidden data-id="element-6" data-mp="ze6gr9ypbdb8" />,
  title: 'Custom AI Development',
  desc: 'Custom-built AI systems designed specifically for your unique goals, learning patterns, and lifestyle preferences—whether for individual use or team implementation.'
}, {
  icon: <TrendingUp className="h-6 w-6" aria-hidden data-id="element-7" data-mp="ihb0bfryayof" />,
  title: 'AI Implementation Training',
  desc: 'Personalized training to help both individuals and teams maximize the potential of your custom AI systems across all aspects of life and business.'
}];
const valuePoints = ['Ultra-personalized approach', 'Absolute discretion', 'Seamless integration'];
const steps = [{
  title: 'Private Consultation',
  body: 'Share your vision and objectives in a confidential discovery session with our founder.',
  icon: <MessageCircle className="h-5 w-5" data-id="element-8" data-mp="1686nfzlgp5pc" />
}, {
  title: 'Strategic Design',
  body: 'We craft a tailored AI strategy customized to your specific requirements and aspirations.',
  icon: <Target className="h-5 w-5" data-id="element-9" data-mp="1f8ld1b5gl6yn" />
}, {
  title: 'Custom Development',
  body: 'Our team builds your personalized AI systems with meticulous attention to detail.',
  icon: <Brain className="h-5 w-5" data-id="element-10" data-mp="3g9rw40428uvr" />
}, {
  title: 'Elite Support',
  body: 'Ongoing premium support and refinement to ensure your AI systems evolve with your needs.',
  icon: <Users className="h-5 w-5" data-id="element-11" data-mp="3c6mtlxjzct74" />
}];
export function FireLitSite() {
  return <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-925 to-slate-900 text-slate-100" data-id="element-12" data-mp="3q15ta18jhilq">
      {/* Nav */}
      <header className="sticky top-0 z-30 backdrop-blur supports-[backdrop-filter]:bg-slate-950/50 border-b border-slate-800" data-id="element-13" data-mp="3smlb2fwua06">
        <div className="mx-auto max-w-6xl px-4 py-4 flex items-center justify-between" data-id="element-14" data-mp="3uzqqdrshvm5y">
          <div className="flex items-center gap-3" data-id="element-15" data-mp="ctuj7jeil8tq">
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-amber-400/20 ring-1 ring-amber-300/50 shadow-lg shadow-amber-300/10" data-id="element-16" data-mp="cr8d7o79v1dm">
              <Flame className="h-7 w-7 text-amber-300" data-id="element-17" data-mp="2elqsemd7m6lc" />
            </div>
            <div className="flex flex-col" data-id="element-18" data-mp="29m4hijkut2fp">
              <span className="font-bold text-2xl tracking-tight text-amber-300" data-id="element-19" data-mp="29n5u4shipwzj">
                FireLit
              </span>
              <span className="text-xs text-slate-400" data-id="element-20" data-mp="p5wnl8sot1ho">
                Personalized AI Excellence
              </span>
            </div>
          </div>
          <nav className="hidden md:flex items-center gap-8 text-sm text-slate-300" data-id="element-21" data-mp="ga72z1z2cb5c">
            <a href="#services" className="hover:text-white" data-id="element-22" data-mp="kc24o7kwoqjn">
              Services
            </a>
            <a href="#contact" className="hover:text-white font-medium text-amber-300" data-id="element-23" data-mp="6csze2y8ngug">
              Schedule Consultation
            </a>
          </nav>
          <div className="flex items-center gap-2" data-id="element-24" data-mp="3tik1qr3115xj">
            <Button asChild className="rounded-2xl" data-id="element-25" data-mp="3tjv0gchm7nhs">
              <a href="#contact" className="inline-flex items-center gap-2" data-id="element-26" data-mp="1f0zalnfwof6">
                <PhoneCall className="h-4 w-4" data-id="element-27" data-mp="1rpvu85jcnwby" /> Private Consultation
              </a>
            </Button>
          </div>
        </div>
      </header>
      {/* Floating CTA */}
      <div className="fixed bottom-6 right-6 z-50 md:hidden" data-id="element-28" data-mp="1vpo2si8qu2hb">
        <Button asChild size="lg" className="rounded-full shadow-lg h-14 w-14 p-0" data-id="element-29" data-mp="170umbu8hm5me">
          <a href="tel:+17205792378" aria-label="Call us" data-id="element-30" data-mp="1206zzlv7ecyi">
            <PhoneCall className="h-6 w-6" data-id="element-31" data-mp="x25b2kb3jjf4" />
          </a>
        </Button>
      </div>
      {/* Hero */}
      <section className="relative overflow-hidden" data-id="element-32" data-mp="s3an73y9v4o5">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_50%_at_50%_0%,rgba(251,191,36,0.12),transparent_60%)]" data-id="element-33" data-mp="o2iecbtbb1se" />
        <div className="mx-auto max-w-6xl px-4 py-24 md:py-32 grid md:grid-cols-2 gap-12 items-center" data-id="element-34" data-mp="jb0b1h3tgp49">
          <motion.div initial="hidden" animate="show" variants={sectionFade} data-id="element-35" data-mp="edgu29fqhy8m">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-amber-300/30 bg-amber-300/10 text-amber-300 text-xs font-medium mb-8" data-id="element-36" data-mp="9edtp2ap8g6z">
              <Clock className="h-3 w-3" data-id="element-37" data-mp="cwbnedqe4fn" /> Limited availability for new clients
            </div>
            <div className="mb-10" data-id="element-38" data-mp="2c09mmkepnigb">
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.2,
              duration: 0.7
            }} className="flex items-center gap-3 mb-3" data-id="element-39" data-mp="2bz80nkw5pbjt">
                <Flame className="h-12 w-12 text-amber-300" data-id="element-40" data-mp="1sdlcj0iap2xs" />
                <h1 className="text-6xl md:text-7xl font-bold tracking-tight text-amber-300" data-id="element-41" data-mp="1xatzdeee1v5d">
                  FireLit
                </h1>
              </motion.div>
              <h2 className="text-3xl md:text-4xl font-semibold leading-tight mt-3" data-id="element-42" data-mp="228dfkjunchzy">
                Impact-Site-Verification: 98c5efb1-8e95-449e-a78f-438a0ecf66af Custom-crafted <span className="text-white" data-id="element-43" data-mp="19kzmiwu2k6l4">AI Systems</span>{' '}
                for Extraordinary Growth
              </h2>
            </div>
            <p className="mt-4 text-slate-300 max-w-prose text-lg leading-relaxed" data-id="element-44" data-mp="1eij1y02i6pen">
              We craft ultra-personalized artificial intelligence solutions for
              both discerning individuals and visionary business leaders with
              teams. FireLit delivers custom AI systems that elevate your
              personal and professional growth to unprecedented heights through
              advanced knowledge retrieval, precision-tuned models, and
              sophisticated workflow automation.
            </p>
            <div className="mt-8 flex flex-wrap gap-4" data-id="element-45" data-mp="jki60qt0l2yw">
              <Button asChild size="lg" className="rounded-2xl" data-id="element-46" data-mp="jlt72iv2rwmb">
                <a href="#contact" className="inline-flex items-center gap-2" data-id="element-47" data-mp="xkasg9xicx12">
                  <Calendar className="h-5 w-5" data-id="element-48" data-mp="sk56nadx64qw" /> Reserve Your Consultation
                </a>
              </Button>
              <a href="#services" className="inline-flex items-center gap-2 text-slate-200 hover:text-white" data-id="element-49" data-mp="28xd8n3vp3kkp">
                Explore our services <ArrowRight className="h-4 w-4" data-id="element-50" data-mp="3lwx88zr99lha" />
              </a>
            </div>
            <div className="mt-8 flex flex-wrap gap-4 text-sm text-slate-300" data-id="element-51" data-mp="3qwt2i7a5hyjn">
              {valuePoints.map(v => <span key={v} className="inline-flex items-center gap-2 rounded-full border border-slate-700 px-4 py-2" data-id="element-52" data-mp="3cxjzyaevb2y5">
                  <CheckCircle2 className="h-4 w-4 text-amber-300" data-id="element-53" data-mp="9g1o7rvz5bsg" /> {v}
                </span>)}
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.98
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5
        }} data-id="element-54" data-mp="dglo337xmtia">
            <div className="relative" data-id="element-55" data-mp="sdvy084xfrbw">
              <div className="absolute -inset-2 rounded-3xl bg-amber-300/10 blur-xl" data-id="element-56" data-mp="sct6bxzs5kux" />
              <Card className="relative rounded-3xl border-slate-800 bg-slate-900/60 backdrop-blur" data-id="element-57" data-mp="x7gzwb9n55gd">
                <CardHeader data-id="element-58" data-mp="2talozk9a39n8">
                  <CardTitle className="flex items-center gap-2" data-id="element-59" data-mp="2oi28aefanye7">
                    <Sparkles className="h-5 w-5 text-amber-300" data-id="element-60" data-mp="2ofpkhkmuutt8" />
                    Personalized AI Systems
                  </CardTitle>
                </CardHeader>
                <CardContent className="grid gap-5" data-id="element-61" data-mp="2ekxkka5svuva">
                  <div className="flex items-start gap-3" data-id="element-62" data-mp="3c74qbndubt98">
                    <div className="mt-1 text-amber-300" data-id="element-63" data-mp="3c6lk33xjytb1">
                      <Brain className="h-6 w-6" data-id="element-64" data-mp="3780hwyyqpzjy" />
                    </div>
                    <div data-id="element-65" data-mp="32976dc30kimf">
                      <div className="font-medium" data-id="element-66" data-mp="328fi6mbqxn66">
                        Tailored to Your Unique Goals
                      </div>
                      <p className="text-sm text-slate-300" data-id="element-67" data-mp="2y7c3421ivv60">
                        AI systems meticulously crafted to align with your
                        specific vision, preferences, and aspirations using
                        proprietary context-aware technologies and specialized
                        model architectures—for both individual users and
                        business teams.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-68" data-mp="baar98netz8w">
                    <div className="mt-1 text-amber-300" data-id="element-69" data-mp="g1j2894e1so6">
                      <Target className="h-6 w-6" data-id="element-70" data-mp="g33vlveyv5kg" />
                    </div>
                    <div data-id="element-71" data-mp="l042u9njyed5">
                      <div className="font-medium" data-id="element-72" data-mp="l0m4xmwwbmsz">
                        Accelerated Personal Growth
                      </div>
                      <p className="text-sm text-slate-300" data-id="element-73" data-mp="u1tt3c5p779c">
                        Harness the power of AI to enhance your capabilities and
                        achieve your full potential faster, whether as an
                        individual or as a business team.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-74" data-mp="30sjuzes942lp">
                    <div className="mt-1 text-amber-300" data-id="element-75" data-mp="13bi8b4y8gnh1">
                      <Workflow className="h-6 w-6" data-id="element-76" data-mp="13d338vogm8ff" />
                    </div>
                    <div data-id="element-77" data-mp="18ale4rm1exq2">
                      <div className="font-medium" data-id="element-78" data-mp="18c5zprqdj6bs">Seamless Integration</div>
                      <p className="text-sm text-slate-300" data-id="element-79" data-mp="1d7lb8d0wsq51">
                        Systems designed to enhance existing workflows for both
                        individuals and teams without disruption or complexity.
                      </p>
                    </div>
                  </div>
                  <div className="mt-2 pt-4 border-t border-slate-800" data-id="element-80" data-mp="1r7csqnqmwons">
                    <Button asChild className="w-full rounded-2xl" data-id="element-81" data-mp="1vze2a1wf41a4">
                      <a href="#contact" className="inline-flex items-center justify-center gap-2" data-id="element-82" data-mp="20yqxb9xg0ens">
                        Schedule Your Private Consultation{' '}
                        <ChevronRight className="h-4 w-4" data-id="element-83" data-mp="2a0gp4gv8lfm3" />
                      </a>
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>
          </motion.div>
        </div>
      </section>
      {/* About */}
      <section id="about" className="mx-auto max-w-6xl px-4 py-16 md:py-20" data-id="element-84" data-mp="3lgjb9geasg5f">
        <motion.div initial="hidden" whileInView="show" viewport={{
        once: true
      }} variants={sectionFade} data-id="element-85" data-mp="3limb0s595nnc">
          <div className="flex items-center gap-2 mb-6" data-id="element-86" data-mp="hz9hh46dwkhs">
            <Flame className="h-7 w-7 text-amber-300" data-id="element-87" data-mp="d0pxh9bcpis2" />
            <h2 className="text-3xl md:text-4xl font-semibold" data-id="element-88" data-mp="d3c3v5mi9s8p">
              The <span className="text-amber-300" data-id="element-89" data-mp="88onju1no457">FireLit</span> Philosophy
            </h2>
          </div>
          <p className="mt-4 text-slate-300 max-w-3xl text-lg leading-relaxed" data-id="element-90" data-mp="3an3p6weo0so">
            FireLit represents the convergence of elite AI expertise and a
            profound understanding of the unique challenges faced by
            high-achieving individuals and entrepreneurs. We believe that truly
            transformative growth requires AI systems as unique as you
            are—meticulously crafted to align with your specific goals,
            preferences, and vision through intelligent knowledge integration,
            optimized language instruction, and seamless workflow automation.
          </p>
          <p className="mt-4 text-slate-300 max-w-3xl text-lg leading-relaxed" data-id="element-91" data-mp="2leuyqe1ryxxc">
            Our team of AI specialists, strategists, and implementation experts
            work exclusively with a limited clientele, ensuring the highest
            level of personalization and discretion in every engagement.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 text-amber-300 font-medium" data-id="element-92" data-mp="22i3hsb9pguwg">
            <a href="#contact" className="inline-flex items-center gap-2 hover:underline text-lg" data-id="element-93" data-mp="3rx1o2b6gp45g">
              Discuss your vision with our founder{' '}
              <ArrowRight className="h-4 w-4" data-id="element-94" data-mp="auorf4jp6zpf" />
            </a>
          </div>
        </motion.div>
      </section>
      {/* Services */}
      <section id="services" className="mx-auto max-w-6xl px-4 py-16 md:py-20" data-id="element-95" data-mp="5wdjizcyqz9u">
        <div className="flex items-center gap-2 mb-6" data-id="element-96" data-mp="jmqsn51lck0r">
          <Flame className="h-7 w-7 text-amber-300" data-id="element-97" data-mp="joa6yq3oskzw" />
          <h2 className="text-3xl md:text-4xl font-semibold" data-id="element-98" data-mp="ew0k5ixvc11u">
            <span className="text-amber-300" data-id="element-99" data-mp="eufnnnrzu81c">FireLit</span> Services
          </h2>
        </div>
        <p className="mt-3 text-slate-300 max-w-3xl text-lg" data-id="element-100" data-mp="tmzqenb8edi9">
          Our comprehensive approach encompasses strategic consulting, custom AI
          development, and personalized implementation training.
        </p>
        <div className="mt-10 grid gap-8 md:grid-cols-3" data-id="element-101" data-mp="ykj3vl03um95">
          {services.map(s => <Card key={s.title} className="rounded-3xl border-slate-800 bg-slate-900/60" data-id="element-102" data-mp="34d81iog8tvhm">
              <CardHeader data-id="element-103" data-mp="30co37hjxoltw">
                <CardTitle className="flex items-center gap-2" data-id="element-104" data-mp="30d7dcc3ce5xd">
                  <span className="text-amber-300" data-id="element-105" data-mp="31tl12sgj8qvk">{s.icon}</span>
                  {s.title}
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-106" data-mp="36tzdemp62mze">
                <p className="text-slate-300" data-id="element-107" data-mp="3atpz4bzu6cx2">{s.desc}</p>
                {s.title === 'AI Consulting' && <ul className="mt-4 text-sm text-slate-300 list-disc pl-5 space-y-2" data-id="element-108" data-mp="3ft2vbnclkwcb">
                    <li data-id="element-109" data-mp="2j2k7yl23fpjx">
                      Strategic AI roadmapping for personal growth and business
                      team development
                    </li>
                    <li data-id="element-110" data-mp="2n1t0xnpb7jef">AI opportunity assessment and prioritization</li>
                    <li data-id="element-111" data-mp="2s2700g8xnj0b">Privacy and security architecture planning</li>
                    <li data-id="element-112" data-mp="2wtypsok9lkpe">Competitive intelligence and AI landscape analysis</li>
                  </ul>}
                {s.title === 'Custom AI Development' && <ul className="mt-4 text-sm text-slate-300 list-disc pl-5 space-y-2" data-id="element-113" data-mp="24de60pbvfl8c">
                    <li data-id="element-114" data-mp="24b1lc4eqawrl">
                      Personalized AI assistants with context-aware knowledge
                      retrieval
                    </li>
                    <li data-id="element-115" data-mp="1rvbkp83q83l8">Custom data analytics and insight generation</li>
                    <li data-id="element-116" data-mp="1muxlmfk3s3zc">
                      Automated workflow systems for business and personal life
                    </li>
                    <li data-id="element-117" data-mp="1itkf0396rwrd">Precision-tuned models for strategic planning</li>
                  </ul>}
                {s.title === 'AI Implementation Training' && <ul className="mt-4 text-sm text-slate-300 list-disc pl-5 space-y-2" data-id="element-118" data-mp="1939aofllbljy">
                    <li data-id="element-119" data-mp="144fyqrlyc2lw">
                      One-on-one training sessions for individuals and
                      comprehensive team training
                    </li>
                    <li data-id="element-120" data-mp="v4jcsxqy5huj">
                      Integration guidance for existing systems and workflows
                    </li>
                    <li data-id="element-121" data-mp="q56i5qtu36he">Advanced usage techniques and optimization</li>
                    <li data-id="element-122" data-mp="ghu6abya24en">Ongoing support and capability expansion</li>
                  </ul>}
                <div className="mt-6 pt-3" data-id="element-123" data-mp="kj60kus3jdt6">
                  <Button asChild variant="outline" className="w-full rounded-xl border-amber-300/20 text-amber-300 hover:bg-amber-300/10" data-id="element-124" data-mp="kkz7mb6mg01p">
                    <a href="#contact" className="inline-flex items-center justify-center gap-1 text-sm" data-id="element-125" data-mp="bktz1xpoyvly">
                      Learn More <ArrowRight className="h-3 w-3" data-id="element-126" data-mp="146vkkftsk9ru" />
                    </a>
                  </Button>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </section>
      {/* Contact / CTA */}
      <section id="contact" className="mx-auto max-w-6xl px-4 py-16 md:py-20" data-id="element-127" data-mp="1i76btjz0jqdj">
        <div className="rounded-3xl border border-slate-800 bg-gradient-to-r from-slate-900 to-slate-875 p-8 md:p-12 relative overflow-hidden" data-id="element-128" data-mp="1i53dmcnpiqxq">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(70%_70%_at_50%_100%,rgba(251,191,36,0.15),transparent_70%)]" data-id="element-129" data-mp="37ni9rlawitkw" />
          <div className="relative" data-id="element-130" data-mp="32n4e72qhlc3r">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-amber-300/30 bg-amber-300/10 text-amber-300 text-xs font-medium mb-6" data-id="element-131" data-mp="3gh53z6zgnorz">
              <Clock className="h-3 w-3" data-id="element-132" data-mp="3ch4nzhwpr5it" /> Limited availability for new clients
            </div>
            <div className="flex items-center gap-3 mb-6" data-id="element-133" data-mp="2orjw29il0xxe">
              <Calendar className="h-8 w-8 text-amber-300" data-id="element-134" data-mp="2jre7513p5pj0" />
              <h3 className="text-3xl md:text-4xl font-semibold" data-id="element-135" data-mp="2xpvtovhv8vzc">
                Limited availability for new client engagements
              </h3>
            </div>
            <p className="mt-3 text-slate-300 max-w-prose text-lg leading-relaxed" data-id="element-136" data-mp="2sppxr34kcnbg">
              To maintain our exceptional level of personalization and service,
              we accept only a limited number of new clients each quarter.
              Secure your private consultation with our founder today.
            </p>
            <div className="mt-10 grid gap-6 md:grid-cols-2 max-w-3xl" data-id="element-137" data-mp="x2108gf11vnz">
              <div className="rounded-2xl border border-slate-700 p-6 bg-slate-800/50" data-id="element-138" data-mp="x29fgeymhd2c">
                <div className="flex items-center gap-3" data-id="element-139" data-mp="1121lajwmt540">
                  <PhoneCall className="h-6 w-6 text-amber-300" data-id="element-140" data-mp="15uuq17s3odg3" />
                  <div data-id="element-141" data-mp="15w5yhkwhq9dj">
                    <h4 className="font-medium text-lg" data-id="element-142" data-mp="1atxno75r3he1">Direct Line</h4>
                    <p className="text-sm text-slate-300" data-id="element-143" data-mp="1avs87kd417hl">
                      Speak confidentially with our founder
                    </p>
                  </div>
                </div>
                <Button asChild size="lg" className="mt-5 w-full rounded-xl" data-id="element-144" data-mp="1kphggkp0pzyk">
                  <a href="tel:+17205792378" className="text-lg" data-id="element-145" data-mp="1osnl5nwhfj2x">
                    720-579-2378
                  </a>
                </Button>
              </div>
              <div className="rounded-2xl border border-slate-700 p-6 bg-slate-800/50" data-id="element-146" data-mp="3qk0o47ew3gwc">
                <div className="flex items-center gap-3" data-id="element-147" data-mp="3j0rgojpy1s9x">
                  <Mail className="h-6 w-6 text-amber-300" data-id="element-148" data-mp="3j2ca260iv567" />
                  <div data-id="element-149" data-mp="3ea2pz6m38zbu">
                    <h4 className="font-medium text-lg" data-id="element-150" data-mp="3e8rlt5oqdpk7">Private Email</h4>
                    <p className="text-sm text-slate-300" data-id="element-151" data-mp="39c9ima91tz9z">
                      We respond within 12 hours
                    </p>
                  </div>
                </div>
                <Button asChild size="lg" variant="outline" className="mt-5 w-full rounded-xl border-amber-300/20 text-amber-300 hover:bg-amber-300/10" data-id="element-152" data-mp="5u95yhsjt5q1">
                  <a href="mailto:jason@firelit.io?subject=Private%20Consultation%20Request" data-id="element-153" data-mp="3sxnosobxkcdy">
                    jason@firelit.io
                  </a>
                </Button>
              </div>
            </div>
            <p className="mt-8 text-sm text-slate-400 flex items-center gap-2" data-id="element-154" data-mp="2hld7be2n02ot">
              <CheckCircle2 className="h-4 w-4 text-amber-300" data-id="element-155" data-mp="2ck5z5dwl11hm" />
              All consultations are protected by our confidentiality agreement
            </p>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="border-t border-slate-800" data-id="element-156" data-mp="183nvhbyx45i1">
        <div className="mx-auto max-w-6xl px-4 py-10 text-sm text-slate-400" data-id="element-157" data-mp="143dsm86f9v7e">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4" data-id="element-158" data-mp="z5c8rl169ruv">
            <div className="flex items-center gap-3" data-id="element-159" data-mp="1vvuz8w6z3erh">
              <Flame className="h-6 w-6 text-amber-300" data-id="element-160" data-mp="1vujrymebjovm" />
              <div data-id="element-161" data-mp="1rthtw8w51iv8">
                <div className="font-semibold text-xl text-amber-300" data-id="element-162" data-mp="1rv2kxoj8ujoc">
                  FireLit
                </div>
                <div data-id="element-163" data-mp="1mstvh25kxzqz">Personalized AI Excellence • Centennial, CO</div>
              </div>
            </div>
            <div className="flex flex-col md:flex-row items-start md:items-center gap-6" data-id="element-164" data-mp="1hxo77wopg8zq">
              <a className="hover:text-slate-200 inline-flex items-center gap-2" href="mailto:jason@firelit.io" data-id="element-165" data-mp="bgswkuf04uxi">
                <Mail className="h-4 w-4 text-amber-300" data-id="element-166" data-mp="3six6zijr6hpo" /> jason@firelit.io
              </a>
              <a className="hover:text-slate-200 inline-flex items-center gap-2" href="tel:+17205792378" data-id="element-167" data-mp="1arrmqxz8n38">
                <PhoneCall className="h-4 w-4 text-amber-300" data-id="element-168" data-mp="68ky7l36zj41" /> 720-579-2378
              </a>
            </div>
          </div>
          <div className="mt-6" data-id="element-169" data-mp="f37vftypcp57">
            © {new Date().getFullYear()}{' '}
            <span className="text-amber-300 font-medium" data-id="element-170" data-mp="f5bwm457va1s">FireLit</span>. All
            rights reserved.
          </div>
        </div>
      </footer>
    </div>;
}